import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import impact from "../../../assets/images/impact.png";
import rotate from "../../../assets/icons/rotate.png";
import give from "../../../assets/icons/give.png";
import graph from "../../../assets/icons/graph.png";
import line from "../../../assets/icons/line.png";
import community from "../../../assets/icons/community.png";

const Impact = () => {
  return (
    <Grid container padding={{ xs: "30% 0%", sm: "4% 2% 7% 0%" }}>
      <Grid items xs={12} sm={12}>
        <Typography
          variant="h3"
          fontWeight={700}
          padding={{ xs: "4% 0%", sm: "4% 0% 2% 0%" }}
          color={"#fff"}
          textAlign={"center"}
        >
          AIR Fund led-impact at a Glance
        </Typography>
      </Grid>
      <Grid items xs={12} sm={12} padding={{ xs: "4% 0%", sm: "1% 0%" }}>
        <Box
          component="img"
          height={{ xs: "78px", sm: "290px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={impact}
          alt={"icons"}
        />
      </Grid>
      {/* <Grid items xs={12} sm={2} padding={{ xs: "15% 0%", sm: "1% 0%" }}>
        <Box
          component="img"
          height={{ xs: "384px", sm: "229px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={community}
          alt={"icons"}
        />
        <Typography
          color={"#fff"}
          variant="h6"
          fontWeight={500}
          padding={{ xs: "4% 0%", sm: "2% 0% 1% 0%" }}
          textAlign={"center"}
        >
          Donors and Partners
        </Typography>
      </Grid>
      <Grid
        items
        xs={12}
        sm={1}
        padding={{ xs: "4% 0%", sm: "1% 0%" }}
        display={{ xs: "none", sm: "inline" }}
      >
        <Box
          component="img"
          height={{ xs: "84px", sm: "250px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={line}
          alt={"icons"}
        />
      </Grid>
      <Grid items xs={12} sm={2} padding={{ xs: "15% 0%", sm: "1% 0%" }}>
        <Box
          component="img"
          height={{ xs: "384px", sm: "230px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={give}
          alt={"icons"}
        />
        <Typography
          color={"#fff"}
          variant="h6"
          fontWeight={500}
          padding={{ xs: "4% 0%", sm: "2% 0% 1% 0%" }}
          textAlign={"center"}
        >
          Contributions & Support
        </Typography>
      </Grid>
      <Grid
        items
        xs={12}
        sm={1}
        padding={{ xs: "4% 0%", sm: "1% 0%" }}
        display={{ xs: "none", sm: "inline" }}
      >
        <Box
          component="img"
          height={{ xs: "184px", sm: "230px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={line}
          alt={"icons"}
        />
      </Grid>
      <Grid items xs={12} sm={2} padding={{ xs: "15% 0%", sm: "1% 0%" }}>
        <Box
          component="img"
          height={{ xs: "384px", sm: "230px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={graph}
          alt={"icons"}
        />
        <Typography
          color={"#fff"}
          variant="h6"
          fontWeight={500}
          padding={{ xs: "4% 0%", sm: "2% 0% 1% 0%" }}
          textAlign={"center"}
        >
          Sustainable Growth
        </Typography>
      </Grid>
      <Grid
        items
        xs={12}
        sm={1}
        padding={{ xs: "4% 0%", sm: "1% 0%" }}
        display={{ xs: "none", sm: "inline" }}
      >
        <Box
          component="img"
          height={{ xs: "84px", sm: "250px" }}
          sx={{
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
          }}
          src={line}
          alt={"icons"}
        />
      </Grid>
      <Grid items xs={12} sm={2} padding={{ xs: "15% 0%", sm: "1% 0%" }}>
        <Box>
          <Box
            component="img"
            height={{ xs: "384px", sm: "230px" }}
            sx={{
              objectFit: "cover",
              overflow: "hidden",
              width: "100%",
            }}
            src={rotate}
            alt={"icons"}
          />
        </Box>
        <Typography
          color={"#fff"}
          variant="h6"
          fontWeight={500}
          padding={{ xs: "4% 0%", sm: "2% 0% 1% 0%" }}
          textAlign={"center"}
        >
          Resource for Impact
        </Typography>
      </Grid> */}
    </Grid>
  );
};

export default Impact;
